import Line from './line';

export default class Highlight extends Line {
    constructor(floor, color, points=[], operator) {
        super(floor, 8, color, points, 0.5, operator, undefined, undefined, undefined, true);
    }
}
